module.exports = __webpack_public_path__ + "files/0e9b65468ce8059f94fd16bce5e4b4c5.png";